import { convertLegacyAppOptions } from '@backstage/core-compat-api';
import { ScmAuth } from '@backstage/integration-react';

// @backstage/integration-react is a plain library (backstage.role: web-library), not
// a frontend-plugin package, so app.packages: all never discovers it - it has to be
// registered explicitly. This is what lets @roadiehq/backstage-plugin-github-insights
// (and any other SCM-auth-consuming plugin picked up by auto-discovery) get a GitHub
// token for the signed-in user; its bundled GithubClient API factory has a hard
// dependency on scmAuthApiRef.
export const scmAuthApis = convertLegacyAppOptions({
  apis: [ScmAuth.createDefaultApiFactory()],
});
